import React from 'react';
import Layout from '../../components/Layout';
import PropertyManagers from './PropertyManagers';

const title = 'BestHand for Property Managers — On-Demand Maintenance Bench';
const description =
  'One on-demand bench of background-checked pros for all your units — dispatched in minutes, upfront itemized pricing, photos on completion, one simple bill. First job: $0 BestHand fees.';

function action() {
  return {
    title,
    description,
    component: (
      <Layout>
        <PropertyManagers />
      </Layout>
    ),
  };
}

export default action;
